export interface Alert {
  alertId: string;
  familyId: string;
  userId?: string; // null means alert is for entire family
  type: AlertType;
  title: string;
  message: string;
  priority: AlertPriority;
  status: AlertStatus;
  metadata?: Record<string, any>;
  createdAt: string;
  updatedAt: string;
}

export enum AlertType {
  INFO = "INFO",
  SUCCESS = "SUCCESS",
  WARNING = "WARNING",
  ERROR = "ERROR",
  ACTIVITY = "ACTIVITY",
  ACHIEVEMENT = "ACHIEVEMENT",
}

export enum AlertPriority {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
  URGENT = "URGENT",
}

export enum AlertStatus {
  UNREAD = "UNREAD",
  READ = "READ",
  DISMISSED = "DISMISSED",
}

export interface CreateAlertPayload {
  familyId: string;
  userId?: string;
  type?: AlertType;
  title: string;
  message: string;
  priority?: AlertPriority;
  metadata?: Record<string, any>;
}

export interface UpdateAlertPayload {
  status: AlertStatus;
}
